import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取图片验证码
import { getShortCode } from 'api/common';
// 登录api
import { login, getQrCode, QrStatus } from 'api/login';
import { utilCookies } from '@/util/cookies'; // token操作
// button
import GlButton from '@/components/gl-button';
export default {
  components: {
    GlButton: GlButton
  },
  data: function data() {
    var str = utilCookies.getLanguage() || 'en';
    return {
      lang: str,
      // 图片验证码
      codeImg: '',
      // 二维码
      qrCode: {},
      qrCodeLoading: false,
      // 登录方式 true 手机号登录  false 二维码登录
      loginMethod: true,
      changeImageUrl: [require('@/assets/img/qrcode.png'), require('@/assets/img/mac.png')],
      disabled: {
        sendCode: false
      },
      surplusTime: 0,
      play: null,
      isRefresh: 0,
      // 表单数据
      ruleForm: {
        calling_code: '66',
        verify_code: '',
        mobile: '',
        checked: !!localStorage.getItem('loginInfo')
      },
      // 校验规则
      rules: {
        mobile: [{
          required: true,
          message: this.$t('login.35'),
          trigger: 'blur'
        }],
        verify_code: [{
          required: true,
          message: this.$t('login.36'),
          trigger: 'blur'
        }]
      },
      // 按钮loading
      loading: false,
      // ---------------邮箱登录相关state数据定义---------------
      tabValue: 'mobile',
      queryLoading: false,
      loginLoading: false,
      emailForm: {
        email: '',
        verify_code: '',
        checked: !!localStorage.getItem('loginInfoByEmail')
      },
      emailRules: {
        email: [{
          required: true,
          message: this.$t('i18n.74db18635ea44101b6434a93669138c9'),
          trigger: 'blur'
        }],
        verify_code: [{
          required: true,
          message: this.$t('login.36'),
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.init();
  },
  computed: {
    isClick: function isClick() {
      var _this$ruleForm = this.ruleForm,
        calling_code = _this$ruleForm.calling_code,
        verify_code = _this$ruleForm.verify_code,
        mobile = _this$ruleForm.mobile;
      var status = calling_code && verify_code && mobile;
      return status;
    },
    loginButtonDisabled: function loginButtonDisabled() {
      var _this$emailForm = this.emailForm,
        email = _this$emailForm.email,
        verify_code = _this$emailForm.verify_code;
      var disabled = !email || !verify_code;
      return disabled;
    },
    codeText: function codeText() {
      if (this.surplusTime === -1) {
        return this.$t('login.4');
      }
      if (this.surplusTime === -2) {
        return this.$t('login.10');
      }
      return this.surplusTime > 0 ? "".concat(this.surplusTime, "S") : this.$t('login.4');
    }
  },
  methods: {
    init: function init() {
      var _this = this;
      this.agreeUrl = "https://backyard-api.flash-hr.com/auth/tool/terms?lang=".concat(this.lang);
      // 判断是否存在token
      if (utilCookies.getToken()) {
        this.$router.push('loginCompany');
      }
      // 是否记住密码 为true说明有设置localStorage
      if (this.ruleForm.checked) {
        var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
        this.ruleForm.mobile = loginInfo.mobile;
      }
      if (this.emailForm.checked) {
        var _loginInfo = JSON.parse(localStorage.getItem('loginInfoByEmail'));
        this.emailForm.email = _loginInfo.email;
      }
      // 是否可以发送验证码 全局mixin方法
      this.resetTimeCode(function (time) {
        if (time <= 0) {
          _this.disabled.sendCode = false;
        }
        _this.surplusTime = time;
      });
    },
    // 短信验证码
    handleShortCode: function handleShortCode() {
      var _this2 = this;
      // 校验是否输入图片验证码和手机号
      if (this.ruleForm.mobile) {
        this.surplusTime = -1;
        getShortCode(this.ruleForm).then(function (res) {
          if (res && res.code === 1) {
            // 获取短信验证码埋点
            _this2.$ga.event('FHRLogin', 'click', 'GetVerificationCode', 3);
            _this2.$s.set('codeTime', new Date().getTime());
            _this2.$message({
              message: _this2.$t('login.33'),
              type: 'success'
            });
            // 全局mixin方法
            _this2.resetTimeCode(function (time) {
              if (time <= 0) {
                _this2.disabled.sendCode = false;
              }
              _this2.surplusTime = time;
            });
          }
        }).catch(function () {
          // 还原发送验证码
          _this2.surplusTime = -2;
        });
      } else {
        this.$message({
          message: this.$t('login.37'),
          type: 'error'
        });
      }
    },
    // 查询邮箱验证码
    handleQueryEmailCode: function handleQueryEmailCode() {
      var _this3 = this;
      this.queryLoading = true;
      this.$http({
        url: '/auth/app/emailCaptcha',
        data: {
          email: this.emailForm.email,
          type: 1
        }
      }).then(function () {
        _this3.$message({
          message: _this3.$t('login.33'),
          type: 'success'
        });
      }).finally(function () {
        _this3.queryLoading = false;
      });
    },
    onMouseleave: function onMouseleave() {
      this.changeImageUrl = [require('@/assets/img/qrcode.png'), require('@/assets/img/mac.png')];
    },
    onMouseenter: function onMouseenter() {
      this.changeImageUrl = [require('@/assets/img/qrcode1.png'), require('@/assets/img/mac1.png')];
    },
    onAgree: function onAgree() {
      // 用户服务协议+使用条款埋点
      this.$ga.event('FHRLogin', 'click', 'UserTerms', 12);
    },
    // 账号登录
    handleLogin: function handleLogin() {
      var _this4 = this;
      // 表单必填项验证
      this.$refs.form.validate(function (valid) {
        if (valid) {
          // 登录管理后台埋点
          _this4.$ga.event('FHRLogin', 'click', 'LoginConsoleButton', 4);
          // 是否记住密码 为true则设置localStorage，为false则删除
          if (_this4.ruleForm.checked) {
            localStorage.setItem('loginInfo', JSON.stringify(_this4.ruleForm));
          } else {
            if (localStorage.getItem('loginInfo')) {
              localStorage.removeItem('loginInfo');
            }
          }
          _this4.loading = true;
          var msg = JSON.parse(JSON.stringify(_this4.ruleForm));
          login(msg).then(function (res) {
            if (res && res.code === 1) {
              _this4.$s.set('userInfo', res.data.user_info);
              utilCookies.setToken(res.data.access_token);
              if (res.data.managed) {
                window.location.reload();
              } else {
                _this4.$router.push({
                  path: '/login/loginWarning'
                });
              }
            }
          }).finally(function () {
            _this4.loading = false;
          });
        }
      });
    },
    // 邮箱登录
    handleEmailLogin: function handleEmailLogin() {
      var _this5 = this;
      // 表单必填项验证
      this.$refs.emailForm.validate(function (valid) {
        if (valid) {
          // 登录管理后台埋点
          _this5.$ga.event('FHRLogin', 'click', 'LoginConsoleButton', 4);
          // 是否记住密码 为true则设置localStorage，为false则删除
          if (_this5.emailForm.checked) {
            localStorage.setItem('loginInfoByEmail', JSON.stringify(_this5.emailForm));
          } else {
            if (localStorage.getItem('loginInfoByEmail')) {
              localStorage.removeItem('loginInfoByEmail');
            }
          }
          _this5.loginLoading = true;
          login(_this5.emailForm).then(function (res) {
            if (res && res.code === 1) {
              _this5.$s.set('userInfo', res.data.user_info);
              utilCookies.setToken(res.data.access_token);
              if (res.data.managed) {
                window.location.reload();
              } else {
                _this5.$router.push({
                  path: '/login/loginWarning'
                });
              }
            }
          }).finally(function () {
            _this5.loginLoading = false;
          });
        }
      });
    },
    // 获取二维码
    handleGetQrCode: function handleGetQrCode(status) {
      var _this6 = this;
      // play存在先删除定时器
      if (this.play) clearInterval(this.play);
      // 遮罩层不展示
      this.isRefresh = 0;
      // status 是为了判断初始化 还是更新验证阿么
      this.qrCodeLoading = true;
      getQrCode().then(function (res) {
        if (res && res.code === 1) {
          _this6.qrCode = res.data;
          _this6.qrCodeLoading = false;
          var self = _this6;
          // 监听二维码登录状态
          if (status) {
            _this6.play = setInterval(function () {
              if (self.loginMethod || _this6.isRefresh === 1) return clearInterval(self.play);
              QrStatus(_this6.qrCode).then(function (res) {
                if (res && res.code === 1) {
                  _this6.isRefresh = 0;
                  _this6.$s.set('userInfo', res.data.user_info);
                  utilCookies.setToken(res.data.access_token);
                  window.location.reload();
                }
                if (res && res.data) {
                  if (res.data.state === 9) _this6.isRefresh = 1;
                  if (res.data.state === 2) _this6.isRefresh = 2;
                }
              });
            }, 1000);
          }
        }
      });
    },
    // 切换登录方式
    handleChangeLoginMethod: function handleChangeLoginMethod() {
      // 切换右上角登录方式埋点
      this.$ga.event('FHRLogin', 'click', this.loginMethod ? 'ScanQR' : 'TelLogin', 1);
      this.loginMethod = !this.loginMethod;
      if (!this.loginMethod) this.handleGetQrCode(true); // 获取验证码
    }
  }
};